/**
 * Expert View Context
 * 
 * Manages the toggle between human-friendly and technical jargon views.
 * When enabled, shows technical terminology instead of accessible labels.
 */

import { createContext, useContext, useState, ReactNode } from 'react';

interface ExpertViewContextType {
  isExpertView: boolean;
  toggleExpertView: () => void;
  setExpertView: (enabled: boolean) => void;
}

const ExpertViewContext = createContext<ExpertViewContextType | undefined>(undefined);

export function ExpertViewProvider({ children }: { children: ReactNode }) {
  const [isExpertView, setIsExpertView] = useState(false);

  const toggleExpertView = () => {
    setIsExpertView(prev => !prev);
  };

  const setExpertView = (enabled: boolean) => {
    setIsExpertView(enabled);
  };

  return (
    <ExpertViewContext.Provider value={{ isExpertView, toggleExpertView, setExpertView }}>
      {children}
    </ExpertViewContext.Provider>
  );
}

export function useExpertView() {
  const context = useContext(ExpertViewContext);
  if (!context) {
    throw new Error('useExpertView must be used within ExpertViewProvider');
  }
  return context;
}
